module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_8019.64e201d6.png";